import { Helmet } from "react-helmet";

function ChatbotHandler() {
  return (
    <>
      <Helmet>
        <script>
          {`(function (g, e, n, es, ys) {
      g["_genesysJs"] = e;
      g[e] =
        g[e] ||
        function () {
          (g[e].q = g[e].q || []).push(arguments);
        };
      g[e].t = 1 * new Date();
      g[e].c = es;
      ys = document.createElement("script");
      ys.async = 1;
      ys.src = n;
      ys.charset = "utf-8";
      document.head.appendChild(ys);
    })(
      window,
      "Genesys",
      "https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js",
      {
        environment: "prod-usw2",
        deploymentId: "9f8b6052-c992-43e9-9c94-b2115a22816e",
      }
    );
    Genesys("subscribe", "Messenger.opened", function () {
      Genesys(
        "command",
        "Database.update",
        {
          messaging: {
            customAttributes: {
              CustomerURL: window.location.href,
            },
          },
        },
        function (data) {},
        function () {}
      );
    });`}
        </script>
      </Helmet>
    </>
  );
}

export default ChatbotHandler;
